/* LZ BN Pokloni funnel — nivoi, zaključani pokloni (samo nagoveštaj), Stefan, otpakivanje, komadi.
   Nivo 2 je višestruki izbor kategorija; nivo 3 traži veličinu za svaku vrstu veličina koje te kategorije koriste
   (slovne S–XXL i brojčane za pantalone/farmerke); na kraju se prikazuju komadi iz svake izabrane kategorije u toj veličini.
   Stanje u sessionStorage, da refresh ne vraća na početak. */
(() => {
  const root = document.querySelector('[data-lzbnp]');
  if (!root || root._lzbnp) return;
  root._lzbnp = true;
  const $ = (sel, el = root) => el.querySelector(sel);
  const $$ = (sel, el = root) => [...el.querySelectorAll(sel)];
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const KEY = 'lzbnp3:' + location.pathname;
  const LIMIT = parseInt(root.dataset.limit, 10) || 6;
  const pad = (n) => String(n).padStart(2, '0');
  let st = { step: 0, style: null, cats: [], sizes: {}, keys: [], opened: [] };
  try { st = Object.assign(st, JSON.parse(sessionStorage.getItem(KEY) || '{}')); } catch (e) {}
  if (!Array.isArray(st.cats)) st.cats = [];
  if (!st.sizes || typeof st.sizes !== 'object') st.sizes = {};
  const save = () => { try { sessionStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} };
  const track = (event, data) => { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event }, data || {})); } catch (e) {} };
  const catLabel = (i) => { const b = $('[data-cat="' + i + '"]'); return b ? (b.dataset.catLabel || '') : ''; };
  const joinLabels = (arr) => arr.map(catLabel).filter(Boolean).join(', ');

  /* Tajmer (uvod + HUD) */
  const cd = $('[data-cd]');
  const end = cd ? Date.parse(cd.dataset.deadline) : NaN;
  const hudTime = $('[data-hud-time]');
  const setU = (u, val) => { const el = cd && cd.querySelector('[data-u="' + u + '"]'); if (el && el.textContent !== val) el.textContent = val; };
  const tick = () => {
    if (isNaN(end)) return;
    let s = Math.max(0, Math.floor((end - Date.now()) / 1000));
    const d = Math.floor(s / 86400); s %= 86400;
    const h = Math.floor(s / 3600); s %= 3600;
    const m = Math.floor(s / 60); s %= 60;
    setU('d', String(d)); setU('h', pad(h)); setU('m', pad(m)); setU('s', pad(s));
    if (hudTime) hudTime.textContent = d + 'd ' + pad(h) + ':' + pad(m) + ':' + pad(s);
  };
  tick(); setInterval(tick, 1000);

  /* HUD prati header sajta: header se pri skrolu nadole sakrije (.custom-header-sticky.is-hidden), pa traka ide na vrh */
  const hud = $('[data-hud]');
  const siteHeader = document.querySelector('.custom-header-sticky') || document.querySelector('.shopify-section-group-header-group');
  const placeHud = () => {
    if (!hud) return;
    const b = siteHeader ? Math.max(0, Math.round(siteHeader.getBoundingClientRect().bottom)) : 0;
    hud.style.top = b + 'px';
  };
  let followUntil = 0;
  const follow = () => { placeHud(); if (performance.now() < followUntil) requestAnimationFrame(follow); };
  const kick = () => { const run = performance.now() >= followUntil; followUntil = performance.now() + 450; if (run) requestAnimationFrame(follow); };
  window.addEventListener('scroll', kick, { passive: true });
  window.addEventListener('resize', kick);
  if (siteHeader && 'MutationObserver' in window) new MutationObserver(kick).observe(siteHeader, { attributes: true, attributeFilter: ['class', 'style'] });
  placeHud();
  const syncHud = () => {
    if (!hud) return;
    hud.hidden = st.step < 1;
    st.keys.forEach((i) => { const k = $('[data-hud-key="' + i + '"]'); if (k) k.classList.add('is-on'); });
    const lvl = $('[data-hud-lvl]');
    const word = root.dataset.labelLevel || 'Nivo';
    if (lvl) lvl.textContent = st.step <= 3 ? word + ' ' + Math.max(1, st.step) + ' / 3' : (st.step === 4 ? '3 / 3 ✓' : '★ Finale');
    const fill = $('[data-hud-fill]');
    if (fill) fill.style.width = Math.min(100, (st.keys.length / 3) * 85 + (st.opened.length / 3) * 15) + '%';
  };

  /* Ekrani */
  const go = (n, opts) => {
    st.step = n; save();
    $$('[data-screen]').forEach((sc) => { const on = sc.dataset.screen === String(n); sc.hidden = !on; sc.classList.toggle('is-active', on); });
    if (n === 2) syncMulti();
    if (n === 3) buildSizes();
    if (n === 5) restoreUnbox();
    syncHud();
    if (!(opts && opts.noScroll)) {
      const top = root.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0);
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    }
    track('lzbnp_step', { step: n });
  };

  /* Konfete */
  const confetti = (cv, n) => {
    if (!cv || reduce) return;
    const r = cv.getBoundingClientRect();
    const W = cv.width = Math.max(1, Math.round(r.width)), H = cv.height = Math.max(1, Math.round(r.height));
    const ctx = cv.getContext('2d');
    const cols = ['#B10F1A', '#E8363C', '#FFFFFF', '#FFD34D'];
    const ps = Array.from({ length: n || 120 }, () => ({ x: W / 2 + (Math.random() - .5) * 60, y: H * .32, vx: (Math.random() - .5) * 12, vy: -Math.random() * 12 - 3, s: 4 + Math.random() * 5, r: Math.random() * 6, vr: (Math.random() - .5) * .4, c: cols[Math.floor(Math.random() * cols.length)] }));
    const t0 = performance.now();
    const step = (t) => {
      ctx.clearRect(0, 0, W, H);
      ps.forEach((p) => { p.vy += .32; p.x += p.vx; p.y += p.vy; p.r += p.vr; ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.fillStyle = p.c; ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * .6); ctx.restore(); });
      if (t - t0 < 2300) requestAnimationFrame(step); else ctx.clearRect(0, 0, W, H);
    };
    requestAnimationFrame(step);
  };

  /* Prozor: osvojen poklon (nagoveštaj) */
  const modal = $('[data-reveal]');
  const nextBtn = $('button[data-reveal-next]');
  let afterReveal = null;
  const earnKey = (i, cb) => {
    if (!st.keys.includes(i)) { st.keys.push(i); save(); }
    syncHud();
    track('lzbnp_key', { key: i });
    if (!modal) { cb && cb(); return; }
    afterReveal = cb;
    $$('[data-reveal-gift]', modal).forEach((g) => { g.hidden = g.dataset.revealGift !== String(i); });
    const k = $('.lzbnp-reveal__key', modal);
    if (k) { k.style.animation = 'none'; void k.offsetWidth; k.style.animation = ''; }
    modal.hidden = false;
    document.body.classList.add('lzbnp-modal');
    setTimeout(() => confetti($('[data-confetti]', modal), 90), 60);
    if (nextBtn) setTimeout(() => nextBtn.focus({ preventScroll: true }), 80);
  };
  const closeReveal = () => {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('lzbnp-modal');
    const cb = afterReveal; afterReveal = null;
    if (cb) cb();
  };
  if (nextBtn) nextBtn.addEventListener('click', closeReveal);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeReveal(); });

  /* Nivo 1: stil */
  $$('[data-style]').forEach((b) => b.addEventListener('click', () => {
    st.style = b.dataset.style; save();
    $$('[data-style]').forEach((x) => x.classList.toggle('is-on', x === b));
    track('lzbnp_style', { style: st.style });
    earnKey(1, () => go(2));
  }));

  /* Nivo 2: kategorije, više njih odjednom; „Dalje“ potvrđuje izbor */
  const multi = $('[data-multi]');
  const multiPicked = $('[data-multi-picked]');
  const multiNext = $('[data-multi-next]');
  const sortedCats = () => st.cats.slice().sort((a, b) => a - b);
  function syncMulti() {
    $$('[data-cat]').forEach((x) => x.classList.toggle('is-on', st.cats.includes(parseInt(x.dataset.cat, 10))));
    if (!multi) return;
    multi.hidden = st.cats.length === 0;
    if (multiPicked) multiPicked.textContent = (root.dataset.pickedWord || '') + ' ' + joinLabels(sortedCats());
    if (multiNext) {
      if (!multiNext.dataset.tpl) multiNext.dataset.tpl = multiNext.textContent;
      multiNext.textContent = multiNext.dataset.tpl.replace('{n}', String(st.cats.length));
    }
  }
  $$('[data-cat]').forEach((b) => b.addEventListener('click', () => {
    const i = parseInt(b.dataset.cat, 10);
    const at = st.cats.indexOf(i);
    if (at >= 0) st.cats.splice(at, 1); else st.cats.push(i);
    st.sizes = {}; save();
    syncMulti();
    track('lzbnp_category', { category: b.dataset.catLabel, on: at < 0 });
  }));
  if (multiNext) multiNext.addEventListener('click', () => {
    if (!st.cats.length) return;
    track('lzbnp_categories', { categories: joinLabels(sortedCats()), count: st.cats.length });
    if (st.keys.includes(2)) go(3); else earnKey(2, () => go(3));
  });

  /* Nivo 3: veličine iz stvarnog stanja izabranih kategorija, po vrsti veličine (slovne / brojčane) */
  const ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL'];
  const rank = (v) => { const i = ORDER.indexOf(String(v).toUpperCase()); if (i >= 0) return i; const n = parseFloat(String(v).replace(/[^0-9.]/g, '')); return isNaN(n) ? 999 : 100 + n; };
  const kind = (sz) => { const u = String(sz).toUpperCase(); if (ORDER.includes(u) || /^[0-9]?X{0,3}[SML]$/.test(u)) return 'abc'; return /\d/.test(u) ? 'num' : 'abc'; };
  const poolItems = (cat) => $$('[data-pool="' + cat + '"] .lzbnp-item');
  const itemSizes = (it) => (it.dataset.sizes || '').split('|').filter(Boolean);
  function sizeGroups() {
    const groups = {};
    sortedCats().forEach((cat) => {
      poolItems(cat).forEach((it) => itemSizes(it).forEach((sz) => {
        const k = kind(sz);
        const g = groups[k] || (groups[k] = { counts: {}, cats: [] });
        g.counts[sz] = (g.counts[sz] || 0) + 1;
        if (!g.cats.includes(cat)) g.cats.push(cat);
      }));
    });
    return ['abc', 'num'].filter((k) => groups[k]).map((k) => Object.assign({ kind: k }, groups[k]));
  }
  const pickedSizes = () => Object.keys(st.sizes).map((k) => st.sizes[k]).filter(Boolean);
  function buildSizes() {
    const box = $('[data-sizes-box]');
    if (!box) return;
    const groups = sizeGroups();
    const multiNote = $('[data-sizes-multi]');
    if (multiNote) multiNote.hidden = groups.length < 2;
    const word = root.dataset.modelsWord || 'modela';
    const left = root.dataset.leftWord || 'još';
    const forWord = root.dataset.sizeForWord || '';
    box.innerHTML = '';
    groups.forEach((g) => {
      const wrap = document.createElement('div');
      wrap.className = 'lzbnp-sizegroup' + (st.sizes[g.kind] ? ' is-done' : '');
      wrap.dataset.sizeKind = g.kind;
      if (groups.length > 1) {
        const h = document.createElement('p');
        h.className = 'lzbnp-sizes__h';
        h.innerHTML = '<span></span> <b></b>';
        h.querySelector('span').textContent = forWord;
        h.querySelector('b').textContent = joinLabels(g.cats);
        wrap.appendChild(h);
      }
      const grid = document.createElement('div');
      grid.className = 'lzbnp-sizes';
      const sizes = Object.keys(g.counts).sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
      sizes.forEach((sz) => {
        const b = document.createElement('button');
        b.type = 'button';
        const low = g.counts[sz] <= 5;
        b.className = 'lzbnp-size' + (low ? ' is-low' : '') + (st.sizes[g.kind] === sz ? ' is-on' : '');
        b.innerHTML = '<b></b><i></i>';
        b.querySelector('b').textContent = sz;
        b.querySelector('i').textContent = (low ? left + ' ' : '') + g.counts[sz] + ' ' + word;
        b.addEventListener('click', () => {
          st.sizes[g.kind] = sz; save();
          $$('.lzbnp-size', grid).forEach((x) => x.classList.toggle('is-on', x === b));
          wrap.classList.add('is-done');
          track('lzbnp_size', { size: sz, kind: g.kind });
          const open = groups.find((og) => !st.sizes[og.kind]);
          if (open) {
            const next = $('[data-size-kind="' + open.kind + '"]', box);
            if (next) next.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
            return;
          }
          if (st.keys.includes(3)) go(4); else earnKey(3, () => go(4));
        });
        grid.appendChild(b);
      });
      wrap.appendChild(grid);
      box.appendChild(wrap);
    });
  }

  /* Otpakivanje */
  const done = $('[data-done]');
  const products = $('[data-products]');
  const openCrate = (i, restore) => {
    const c = $('[data-crate="' + i + '"]');
    if (!c || c.classList.contains('is-opened')) return;
    const finish = () => {
      c.classList.remove('is-shaking', 'is-popping');
      c.classList.add('is-opened');
      const closed = $('.lzbnp-crate__closed', c); if (closed) closed.hidden = true;
      const open = $('.lzbnp-crate__open', c); if (open) open.hidden = false;
      if (!st.opened.includes(i)) { st.opened.push(i); save(); }
      syncHud();
      if (!restore) track('lzbnp_gift', { gift: i });
      if (st.opened.length >= 3) finishAll(restore);
    };
    if (restore || reduce) { finish(); return; }
    c.classList.add('is-shaking');
    setTimeout(() => c.classList.add('is-popping'), 650);
    setTimeout(finish, 1050);
  };
  $$('[data-crate-open]').forEach((b) => b.addEventListener('click', () => openCrate(parseInt(b.dataset.crateOpen, 10))));
  function finishAll(restore) {
    if (done) done.hidden = false;
    const hint = $('[data-unbox-hint]'); if (hint) hint.hidden = true;
    buildFinal();
    if (products) products.hidden = false;
    if (!restore) {
      confetti($('[data-confetti-page]'), 180);
      markCart();
      setTimeout(() => done && done.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }), 400);
    }
  }
  function restoreUnbox() { st.opened.slice().forEach((i) => openCrate(i, true)); }

  /* Komadi: svaka izabrana kategorija, u izabranoj veličini te vrste; „Sve u crnom“ stavlja crne modele prve */
  function buildFinal() {
    const cats = sortedCats();
    const picked = pickedSizes();
    const perPool = cats.length > 1 ? Math.min(LIMIT, 4) : LIMIT;
    if (products) products.classList.toggle('is-multi', cats.length > 1);
    $$('[data-pool]').forEach((p) => { p.hidden = !cats.includes(parseInt(p.dataset.pool, 10)); });
    const wrap = $('[data-pools]');
    cats.forEach((cat) => {
      const pool = $('[data-pool="' + cat + '"]');
      if (!pool) return;
      if (wrap) wrap.appendChild(pool);
      const grid = $('[data-grid]', pool);
      let items = poolItems(cat);
      if (st.style === '3') items = items.filter((i) => i.dataset.black === 'true').concat(items.filter((i) => i.dataset.black !== 'true'));
      const fit = items.filter((it) => itemSizes(it).some((sz) => picked.includes(sz)));
      const show = (fit.length ? fit : items).slice(0, perPool);
      items.forEach((it) => { it.hidden = !show.includes(it); });
      if (grid) show.forEach((it) => grid.appendChild(it));
      const t = $('[data-pool-title]', pool);
      if (t) {
        const sz = fit.length ? picked.filter((p) => show.some((it) => itemSizes(it).includes(p))) : [];
        t.hidden = cats.length < 2;
        t.textContent = catLabel(cat) + (sz.length ? ' · ' + sz.join(' / ') : '');
      }
    });
    $$('[data-more-cat]').forEach((c) => { c.hidden = cats.includes(parseInt(c.dataset.moreCat, 10)); });
    const more = $('[data-more]'); if (more) more.hidden = $$('[data-more-cat]').every((c) => c.hidden);
    buildSwitch();
    const t = $('[data-final-title]');
    if (t) {
      if (!t.dataset.tpl) t.dataset.tpl = t.textContent;
      if (picked.length === 1) t.textContent = t.dataset.tpl.replace('{size}', picked[0]);
      else if (picked.length > 1) t.textContent = root.dataset.titleMulti || t.dataset.tpl.replace('{size}', picked.join(' / '));
      else t.textContent = t.dataset.tpl.replace(/\s*\S*\s*\{size\}/, '');
    }
  }

  /* Promena veličine na kraju (Marko 03.11.2026): bez vraćanja kroz nivoe, pokloni ostaju */
  function buildSwitch() {
    const box = $('[data-size-switch]');
    if (!box) return;
    const groups = sizeGroups();
    box.innerHTML = '';
    if (!groups.length) { box.hidden = true; return; }
    groups.forEach((g) => {
      const row = document.createElement('div');
      row.className = 'lzbnp-szsw__row';
      if (groups.length > 1) {
        const lab = document.createElement('span');
        lab.className = 'lzbnp-szsw__label';
        lab.textContent = joinLabels(g.cats) + ':';
        row.appendChild(lab);
      }
      Object.keys(g.counts).sort((a, b) => rank(a) - rank(b) || a.localeCompare(b)).forEach((sz) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'lzbnp-szsw__btn' + (st.sizes[g.kind] === sz ? ' is-on' : '');
        b.textContent = sz;
        b.setAttribute('aria-pressed', st.sizes[g.kind] === sz ? 'true' : 'false');
        b.addEventListener('click', () => {
          if (st.sizes[g.kind] === sz) return;
          st.sizes[g.kind] = sz; save();
          track('lzbnp_size_change', { size: sz, kind: g.kind });
          buildFinal();
        });
        row.appendChild(b);
      });
      box.appendChild(row);
    });
    if (box.dataset.label) {
      const h = document.createElement('p'); h.className = 'lzbnp-szsw__label lzbnp-szsw__label--top'; h.textContent = box.dataset.label;
      box.insertBefore(h, box.firstChild);
    }
    box.hidden = false;
  }

  async function markCart() {
    const name = root.dataset.attrName, value = root.dataset.attrValue;
    try {
      if (name) await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { [name]: value } }) });
      if (root.dataset.code) await fetch('/discount/' + encodeURIComponent(root.dataset.code), { credentials: 'same-origin' });
    } catch (e) {}
  }

  /* Navigacija */
  $$('[data-next]').forEach((b) => b.addEventListener('click', () => go(parseInt(b.dataset.next, 10))));
  $$('[data-back]').forEach((b) => b.addEventListener('click', () => go(parseInt(b.dataset.back, 10))));

  /* Povratak posle osvežavanja */
  if (st.style) { const o = $('[data-style="' + st.style + '"]'); if (o) o.classList.add('is-on'); }
  syncMulti();
  const valid = st.step <= 2 || st.cats.length > 0;
  if (st.step > 0 && valid) go(st.step, { noScroll: true }); else { st.step = 0; syncHud(); }
})();
